/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { BANNER_HEIGHT } from '../configs/constants';

const BASE_BANNER_WIDTH = 375;
export const MAX_BANNER_HEIGHT = 200;
const LISTING_BANNER_DESKTOP_MIN_WIDTH = 600;
export const LISTING_BANNER_MOBILE_HEIGHT = 84;
export const LISTING_BANNER_DESKTOP_HEIGHT = 110;

export const getResponsiveBannerHeight = (width: number) => {
  if (!width || width <= 0) {
    return BANNER_HEIGHT;
  }

  const scaledHeight = Math.round((width / BASE_BANNER_WIDTH) * BANNER_HEIGHT);

  return Math.min(MAX_BANNER_HEIGHT, Math.max(BANNER_HEIGHT, scaledHeight));
};

export const getResponsiveListingBannerHeight = (width: number) =>
  width >= LISTING_BANNER_DESKTOP_MIN_WIDTH
    ? LISTING_BANNER_DESKTOP_HEIGHT
    : LISTING_BANNER_MOBILE_HEIGHT;
